import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _objectSpread from "/app/src/Web/InternetBranch/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import request from "../utils/request";
import store from "../store";

// var cors = require('cors')
// var express = require('express')
// var app = express()
// app.use(cors())

var identityServerUrl = process.env.VUE_APP_IDENTITY_SERVICE !== undefined ? process.env.VUE_APP_IDENTITY_SERVICE : 'https://id-test.iyifinans.com.tr/';
export function loginByUsername(form) {
  var data = _objectSpread(_objectSpread({
    client_id: 'internet',
    grant_type: 'password'
  }, form), {}, {
    loginSource: 'internet'
  });
  var config = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };
  var dataString = Object.keys(data).map(function (k) {
    return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(data[k]));
  }).join('&');
  return request('post', 'connect/token', dataString, identityServerUrl, config);
}
export function logout() {
  return new Promise(function (resolve) {
    // request('get', '/connect/endsession', undefined, identityServerUrl)
    request('get', '/account/logout?userName=' + store.getters.user.username, undefined, identityServerUrl).then(function () {
      return resolve();
    }).catch(function () {
      return resolve();
    });
  });
}
export function getParameterTypes() {
  return request('get', 'api/f/v1/parameter/parameters?isActive=' + true + '&isPassive=' + false);
  // return request('get', 'connect/parameters', undefined, identityServerUrl)
}
export function getUserInfo() {
  return request('get', 'connect/userinfo', undefined, identityServerUrl);
}
export function changePassword(model) {
  return request('post', 'Account/MobileChangePassword', model, identityServerUrl);
}